import { connect } from "react-redux";

import { RubbleTicket } from "../../interface/api/RubbleTicket";
import rubbleTicketService from "../../services/rubbleTicketService";
import { useDigitalTicket } from "../../hooks/useDigitalTicket";
import TicketLoading from "../shared/ticket-loading";
import RubblePrintableTicket from "./rubble-printable-ticket";

/**
 * /rubble-digital-ticket/:id - the printable ticket, staff only. Read-only by
 * design: every edit path lives on /rubble/:id.
 */
const RubbleDigitalTicketView = () => {
  const { ticket, ticketUrl } = useDigitalTicket<RubbleTicket>(
    rubbleTicketService,
    "rubble"
  );

  if (!ticket) return <TicketLoading />;

  return <RubblePrintableTicket ticket={ticket} ticketUrl={ticketUrl} />;
};

export default connect()(RubbleDigitalTicketView);
